export class UserMessage {
  public static readonly loginIssue = 'It appears your session has expired';
  public static readonly sessionExpiredMsg = 'Your session has expired due to inactivity';
  public static readonly genericFailureMsg = 'Something went wrong';
  public static readonly unableToLogin = 'Unable to login';
  public static readonly portalNotEnabled = 'Sorry but your current Destiny is not enabled for new user experience. Please contact your Destiny Administrator to have it enabled.';
  public static readonly learnMoreMsg = 'If the issue persists, please contact customer support and provide them with the error code';

  // Toast Messages
  public static readonly launchToVendorFailed = (app: string) => `Unable to launch to ${app} at this time.`;
  public static readonly switchingSitesFailed = 'Unable to switch to requested school.';
  public static readonly siteSwitchedTo = 'Switched to ';
  public static readonly copiedToClipboard = 'Copied details to Clipboard.';
}

export class MessageCode {
  public static readonly ERROR_UNABLE_TO_LOGIN = 1000;
  public static readonly ERROR_AUTH_CODE_REDEEM_FAILED = 1001;
  public static readonly ERROR_LOGIN_ISSUE = 1002;
  public static readonly ERROR_SESSION_EXPIRED = 1003;
  public static readonly ERROR_GRANTS_FAILED = 1004;
  public static readonly ERROR_REFRESH_TOKEN_INVALID = 1005;
  public static readonly ERROR_SWITCHING_SITES_FAILED = 1006;
  public static readonly ERROR_TITLEWAVE_LAUNCH_FAILED = 1007;
  public static readonly ERROR_MISSING_REDEMPTION_CODE = 1008;
  public static readonly ERROR_PORTAL_NOT_ENABLED = 1009;
}
